module.exports = __webpack_public_path__ + "static/media/48380610_2308773335864511_814816181507588096_o-thumb.368bd08c.jpg";